import {
  Button as MuiButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup
} from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'

import { closeAtHomeBooking } from 'api/atHome'
import constants from 'app/constants'
import { eventAlert } from 'app/helpers'

import { slotHasStarted } from './format'

/** A booked session whose start time has passed and nobody marked: ops close it. */
export const canClose = (row) =>
  row.status === 'booked' && slotHasStarted(row.date, row.startTime)

/**
 * Record what happened at a session the teacher never closed (owner,
 * 2026-10-13), from Bookings. Either way the row stays under Bookings;
 * Attended also lists it under Attended.
 */
const CloseSessionDialog = ({ row, onClose, onDone }) => {
  const [attended, setAttended] = React.useState('yes')
  const [saving, setSaving] = React.useState(false)

  React.useEffect(() => {
    setAttended('yes')
  }, [row])

  const submit = async () => {
    setSaving(true)
    try {
      await closeAtHomeBooking(row.uuid, attended === 'yes')
      eventAlert(
        attended === 'yes'
          ? 'Marked as attended. It now also shows under Attended, and the parent will be asked how it went.'
          : 'Marked as a no-show. The parent now sees it as missed, and nothing is sent to them.',
        constants.SUCCESS
      )
      onDone()
    } catch (error) {
      // toast from request.js
    } finally {
      setSaving(false)
    }
  }

  return (
    <Dialog
      open={Boolean(row)}
      onClose={() => !saving && onClose()}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle>Record what happened</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {row
            ? `${row.childName}'s ${row.categoryName} session on ${row.dateLabel} was never closed by ${row.teacherName}. Record what happened.`
            : ''}
        </DialogContentText>
        <RadioGroup
          value={attended}
          onChange={(e) => setAttended(e.target.value)}
        >
          <FormControlLabel
            value="yes"
            control={<Radio color="primary" />}
            label="Attended — it happened. The parent sees it as completed and is asked how it went."
          />
          <FormControlLabel
            value="no"
            control={<Radio color="primary" />}
            label="No-show — the child was not taught. The parent sees it as missed, and we send them nothing."
          />
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <MuiButton onClick={onClose} disabled={saving}>
          Back
        </MuiButton>
        <MuiButton
          onClick={submit}
          color="primary"
          variant="contained"
          disabled={saving}
        >
          {attended === 'yes' ? 'Mark attended' : 'Mark no-show'}
        </MuiButton>
      </DialogActions>
    </Dialog>
  )
}

CloseSessionDialog.propTypes = {
  row: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired
}

export default CloseSessionDialog
